import React from 'react'
import CustomDatePicker from './customDatePicker'



const CustomDatePickerDMY = ({ selected, onChange, className, dateFormat, placeholderText, minDate, disabled }) => {
    return (
        <CustomDatePicker
            selected={selected}
            onChange={onChange}
            dateFormat={dateFormat}
            className={className}
            placeholderText={placeholderText}
            showYearDropdown={true}
            scrollableYearDropdown={true}
            showMonthDropdown={true}
            useShortMonthInDropdown={true}
            disabled={disabled}
            minDate={minDate}
        />
    )
}

export default CustomDatePickerDMY
